// Roman numeral helpers
export const ROMANS = ["I","II","III","IV","V","VI","VII","VIII","IX","X","XI"];

export const formatINR = (v) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(v);

// Small emblem components used across the site — geometric, thin-line, monochrome.
// The intent is a family of chapter marks; they render as SVGs so they scale for
// navigation, product labels and hero displays without pixellation.
export function ChapterEmblem({ roman, size = 64, stroke = "currentColor" }) {
  const paths = EMBLEMS[roman] || EMBLEMS.default;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" stroke={stroke} strokeWidth="0.75" strokeLinecap="square" aria-hidden="true">
      <rect x="1" y="1" width="62" height="62" opacity="0.35" />
      {paths}
    </svg>
  );
}

const EMBLEMS = {
  I:   <><line x1="32" y1="10" x2="32" y2="54" /></>,
  II:  <><circle cx="32" cy="32" r="16" /><line x1="16" y1="32" x2="48" y2="32" /></>,
  III: <><polygon points="32,10 54,50 10,50" /></>,
  IV:  <><rect x="14" y="14" width="36" height="36" /><line x1="14" y1="14" x2="50" y2="50" /></>,
  V:   <><path d="M12 14 L32 54 L52 14" /></>,
  VI:  <><circle cx="32" cy="32" r="18" /><line x1="32" y1="14" x2="32" y2="50" /></>,
  VII: <><line x1="14" y1="14" x2="50" y2="14" /><line x1="32" y1="14" x2="32" y2="50" /></>,
  VIII:<><circle cx="24" cy="26" r="10" /><circle cx="40" cy="38" r="10" /></>,
  IX:  <><polygon points="10,32 32,10 54,32 32,54" /></>,
  X:   <><line x1="14" y1="14" x2="50" y2="50" /><line x1="50" y1="14" x2="14" y2="50" /></>,
  XI:  <><line x1="24" y1="12" x2="24" y2="52" /><line x1="40" y1="12" x2="40" y2="52" /></>,
  default: <><rect x="12" y="12" width="40" height="40" /></>,
};
